const convertImage = (value, fromUnit, toUnit, additionalParams = {}) => {
  const { width, height, ppi, dpi } = additionalParams;

  switch (`${fromUnit} to ${toUnit}`) {
    case 'Pixels to Inches':
      return value / (ppi || dpi || 96);
    case 'Inches to Pixels':
      return value * (ppi || dpi || 96);
    case 'Pixels to Centimeters':
      return (value / (ppi || dpi || 96)) * 2.54;
    case 'Centimeters to Pixels':
      return (value / 2.54) * (ppi || dpi || 96);
    case 'PPI (Pixels per Inch) to DPI (Dots per Inch)':
    case 'DPI (Dots per Inch) to PPI (Pixels per Inch)':
      return value; // PPI and DPI are equivalent for digital images
    case 'PPI (Pixels per Inch) to PPCM (Pixels per Centimeter)':
      return value / 2.54;
    case 'PPCM (Pixels per Centimeter) to PPI (Pixels per Inch)':
      return value * 2.54;
    case 'Pixels to Megapixels':
      return (width * height) / 1000000;
    case 'Megapixels to Pixels':
      return value * 1000000;
    case 'Pixels to Aspect Ratio':
      return `${width}:${height}`;
    case 'Aspect Ratio to Pixels':
      const [w, h] = value.split(':').map(Number);
      return `Width: ${(height * w) / h}, Height: ${height}`;
    default:
      throw new Error('Unsupported conversion');
  }
};

export { convertImage };
